<div
  id="cookie-consent"
  #cookieConsentBanner
  class="cookie-consent-popup-container"
  *ngIf="showCookieBanner && isBrowser"
>
  <div
    class="cookie-consent-popup-title"
    [attr.data-translate]="'cookie.consent.popup.title'"
    i18n="@@cookie.consent.popup.title"
  >
    Cookies consent
  </div>

  <div class="cookie-consent-popup-message" [attr.data-translate]="'cookie.consent.popup.message'">
    <span i18n="@@cookie.consent.popup.message"
      >We use cookies on this site to improve your experience, for analytics and to deliver relevant advertising. Some
      are strictly necessary to run the site while others are optional.
    </span>
  </div>
  <div class="buttons">
    <div class="cookie-consent-popup-accept">
      <button
        type="button"
        (click)="acceptAll()"
        i18n="@@cookie.consent.popup.button.acceptAll"
        [attr.data-translate]="'cookie.consent.popup.button.acceptAll'"
      >
        Accept all
      </button>
    </div>

    <div class="cookie-consent-popup-accept">
      <button
        type="button"
        (click)="rejectAll()"
        i18n="@@cookie.consent.popup.button.rejectAll"
        [attr.data-translate]="'cookie.consent.popup.button.rejectAll'"
      >
        Reject all
      </button>
    </div>
  </div>

  <div class="cookie-consent-popup-customize">
    <button
      type="button"
      (click)="showCookieCustomizationDialog()"
      i18n="@@cookie.consent.popup.button.customize"
      [attr.data-translate]="'cookie.consent.popup.button.customize'"
    >
      Customize settings
    </button>
    @if (cookiePolicyUrl) {
      <a
        class="cookie-consent-policy-link"
        [href]="cookiePolicyUrl"
        i18n="@@cookie.consent.policyLink"
        [attr.data-translate]="'cookie.consent.policyLink'"
        >Cookie Policy</a
      >
    }
  </div>
</div>

<p-dialog
  [(visible)]="displayCookieDialog"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  header="Customize cookie preferences"
  i18n-header="@@cookie.consent.dialog.title"
>
  <div class="cookie-settings-content">
    <div class="cookie-settings-msg" *ngIf="customCookiesMsg">{{ customCookiesMsg }}</div>
    <div class="cookie-settings-information">
      @if (cookiePolicyUrl) {
        <p class="cookie-settings-policy-description">
          <span i18n="@@cookie.consent.policyDescription">
            View the individual technologies, providers, purposes, and durations in our
          </span>
          <a
            class="cookie-settings-policy-link"
            [href]="cookiePolicyUrl"
            i18n="@@cookie.consent.policyDetailsLink"
            [attr.data-translate]="'cookie.consent.policyDetailsLink'"
            >Cookie Policy</a
          >.
        </p>
      }
      @if (consentProviderName) {
        <p i18n="@@cookie.consent.providerDisclosure">
          Cookie preferences are managed using {{ consentProviderName }}'s consent tool.
        </p>
      }
    </div>
    <div class="cookie-settings-options">
      <div [class.highlight]="cookieSettings?.analytics_storage?.highlighted" class="cookie-setting-option">
        <span>
          <label
            i18n="@@cookie.consent.dialog.analytics_storage"
            [attr.data-translate]="'cookie.consent.dialog.analytics_storage'"
            >Analytics cookies</label
          >
          <ush-tooltip position="down" tooltipId="cookie-tooltip-analytics-storage" triggerMode="both">
            <fa-icon
              [icon]="faQuestionCircle"
              class="tooltip-icon"
              tabindex="0"
              aria-describedby="cookie-tooltip-analytics-storage"
            ></fa-icon>
            <span
              ushTooltipContent
              i18n="@@cookie.consent.dialog.analytics_storage.tooltip"
              [attr.data-translate]="'cookie.consent.dialog.analytics_storage.tooltip'"
              >Measuring website load speeds and general site performance</span
            >
          </ush-tooltip>
        </span>
        <p-inputSwitch
          [ngModel]="cookieSettings?.analytics_storage.enabled"
          (ngModelChange)="cookieSettings.analytics_storage.enabled = $event"
        ></p-inputSwitch>
      </div>
      <div
        [hidden]="!hasTargetingPlatforms"
        [class.highlight]="cookieSettings?.ad_storage?.highlighted"
        class="cookie-setting-option"
      >
        <span>
          <label i18n="@@cookie.consent.dialog.ad_storage" [attr.data-translate]="'cookie.consent.dialog.ad_storage'"
            >Targeting cookies</label
          >
          <ush-tooltip tooltipId="cookie-tooltip-ad-storage">
            <fa-icon
              [icon]="faQuestionCircle"
              class="tooltip-icon"
              tabindex="0"
              aria-describedby="cookie-tooltip-ad-storage"
            ></fa-icon>
            <span ushTooltipContent [attr.data-translate]="'cookie.consent.dialog.ad_storage.tooltip'"
              >Third Party Cookies used by advertisers to serve you with advertising on other platforms. They may be
              from Social media platforms or other advertising platforms.</span
            >
          </ush-tooltip>
        </span>
        <p-inputSwitch
          [ngModel]="cookieSettings?.ad_storage.enabled"
          (ngModelChange)="cookieSettings.ad_storage.enabled = $event"
        ></p-inputSwitch>
      </div>

      <div [class.highlight]="cookieSettings?.functionality_storage?.highlighted" class="cookie-setting-option">
        <span>
          <label
            i18n="@@cookie.consent.dialog.functionality_storage"
            [attr.data-translate]="'cookie.consent.dialog.functionality_storage'"
            >Functionality cookies</label
          >
          <ush-tooltip tooltipId="cookie-tooltip-functionality-storage">
            <fa-icon
              [icon]="faQuestionCircle"
              class="tooltip-icon"
              tabindex="0"
              aria-describedby="cookie-tooltip-functionality-storage"
            ></fa-icon>
            <span
              ushTooltipContent
              i18n="@@cookie.consent.dialog.functionality_storage.tooltip"
              [attr.data-translate]="'cookie.consent.dialog.functionality_storage.tooltip'"
              >Enables storage that supports the functionality of the website or app e.g. language settings, trailer
              views.</span
            >
          </ush-tooltip>
        </span>
        <p-inputSwitch
          [ngModel]="cookieSettings?.functionality_storage.enabled"
          (ngModelChange)="cookieSettings.functionality_storage.enabled = $event"
        ></p-inputSwitch>
      </div>

      <div
        *ngIf="allowLoginChange"
        [class.highlight]="cookieSettings?.social_login?.highlighted"
        class="cookie-setting-option"
      >
        <span>
          <label
            i18n="@@cookie.consent.dialog.social_login"
            [attr.data-translate]="'cookie.consent.dialog.social_login'"
            >Social Networks Login cookies</label
          >
          <ush-tooltip tooltipId="cookie-tooltip-social-login" triggerMode="both">
            <fa-icon
              [icon]="faQuestionCircle"
              class="tooltip-icon"
              tabindex="0"
              aria-describedby="cookie-tooltip-social-login"
            ></fa-icon>
            <span
              ushTooltipContent
              i18n="@@cookie.consent.dialog.social_login.tooltip"
              [attr.data-translate]="'cookie.consent.dialog.social_login.tooltip'"
              >Support for logging in with Google or Facebook.</span
            >
          </ush-tooltip>
        </span>
        <p-inputSwitch
          [ngModel]="cookieSettings?.social_login.enabled"
          (ngModelChange)="cookieSettings.social_login.enabled = $event"
        ></p-inputSwitch>
      </div>

      <div [class.highlight]="cookieSettings?.security_storage?.highlighted" class="cookie-setting-option">
        <span>
          <label
            i18n="@@cookie.consent.dialog.security_storage"
            [attr.data-translate]="'cookie.consent.dialog.security_storage'"
            >Security cookies</label
          >
          <ush-tooltip tooltipId="cookie-tooltip-security-storage" triggerMode="both">
            <fa-icon
              [icon]="faQuestionCircle"
              class="tooltip-icon"
              tabindex="0"
              aria-describedby="cookie-tooltip-security-storage"
            ></fa-icon>
            <span
              ushTooltipContent
              i18n="@@cookie.consent.dialog.security_storage.tooltip"
              [attr.data-translate]="'cookie.consent.dialog.security_storage.tooltip'"
              >Enables storage related to security such as authentication functionality, fraud prevention, and other
              user protection</span
            >
          </ush-tooltip>
        </span>
        <p-inputSwitch
          [ngModel]="cookieSettings?.security_storage.enabled"
          (ngModelChange)="cookieSettings.security_storage.enabled = $event"
        ></p-inputSwitch>
      </div>

      <div class="cookie-setting-option">
        <span>
          <label
            i18n="@@cookie.consent.dialog.strictly.necessary"
            [attr.data-translate]="'cookie.consent.dialog.strictly.necessary'"
          >
            Strictly necessary</label
          >
          <ush-tooltip tooltipId="cookie-tooltip-strictly-necessary" triggerMode="both">
            <fa-icon
              [icon]="faQuestionCircle"
              class="tooltip-icon"
              tabindex="0"
              aria-describedby="cookie-tooltip-strictly-necessary"
            ></fa-icon>
            <span
              ushTooltipContent
              i18n="@@cookie.consent.dialog.strictly.necessary.tooltip"
              [attr.data-translate]="'cookie.consent.dialog.strictly.necessary.tooltip'"
              >These cookies are the core ones to enable the functionality of the site. They are used to remember your
              location if you have given it, which allows us to show you relevant film, showtime and streaming
              information. For sites with log in functionality, cookies are used to remember your account.</span
            >
          </ush-tooltip>
        </span>
        <p-inputSwitch [disabled]="true" [ngModel]="true"></p-inputSwitch>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="cookie-settings-footer">
      <p-button
        [text]="true"
        label="Cancel"
        i18n-label="@@cookie.consent.dialog.footer.discard"
        [attr.data-translate]="'cookie.consent.dialog.footer.discard'"
        (click)="cancelSettings()"
      >
      </p-button>
      <p-button
        type="button"
        [text]="true"
        label="Accept"
        i18n-label="@@cookie.consent.dialog.footer.accept"
        [attr.data-translate]="'cookie.consent.dialog.footer.accept'"
        (click)="acceptChoices()"
      >
      </p-button>
    </div>
  </ng-template>
</p-dialog>
